<script setup>
const props = defineProps({
    modelValue: { type: Number, default: 10 }
})

const emits = defineEmits(['update:modelValue', 'change'])

const handleChange = (val) => {
    emits('update:modelValue', val)
    emits('change', val)
}
</script>

<template>
    <div class="per-page-select is-flex is-align-items-center mb-2">
        <span class="mr-2 is-size-7 has-text-grey">{{ $t('labels.per_page') }}</span>
        <b-select :model-value="modelValue" size="is-small" @update:model-value="handleChange">
            <option :value="10">10</option>
            <option :value="100">100</option>
            <option :value="500">500</option>
            <option :value="1000">1000</option>
        </b-select>
    </div>
</template>
